import { Colors, Metrics, Typography } from "../../resources";
import { Pressable, ScrollView, StyleSheet, View } from "react-native";
import React, { useRef, useState } from "react";
import { SIconType, STagType, Tag, TagMap } from "../../types";
import _, { noop } from "lodash";

import { SIcon } from "../atoms";
import STagsBar from "../molecules/STagsBar";
import { useOnclickOutside } from "../../hooks";

interface IProps {
  tags: TagMap;
  type: STagType;
  setTagEdit: (edited: boolean) => void;
  flexWrap?: boolean;
  height?: number;
  width?: number | string;
  onClick?: (tag: Tag) => void;
  onEdit?: (tag: Tag) => void;
}

const STagsEditBar: React.FC<IProps> = ({
  tags,
  height = Metrics.size44,
  setTagEdit,
  width = "100%",
  flexWrap = false,
  type,
  onClick = noop,
  onEdit = noop,
}) => {
  const [isVisible, setIsvisible] = useState<boolean>(false);
  const [containerWidth, setContainerWidth] = useState<number>(0);
  const [tagsWidth, setTagsWidth] = useState<number>(0);
  const [tagsHover, setTagsHover] = useState<boolean>(false);
  const [tagsPressIn, setTagsPressIn] = useState<boolean>(false);

  const modalRef = useRef<any>(null);

  const onTagsHoverIn = () => setTagsHover(true);
  const onTagsHoverOut = () => setTagsHover(false);
  const onTagsPressIn = () => {
    setTagsPressIn(true);
  };

  const onTagsPressOut = () => {
    setTagsPressIn(false);
  };

  const onPress = () => {
    setTagEdit(!isVisible);
    setIsvisible((isVisible) => !isVisible);
  };

  const isToolTipEnabled: () => boolean = () => {
    return containerWidth < tagsWidth && !isVisible;
  };

  const onWidth = (width: number) => {
    setTagsWidth(width);
  };

  useOnclickOutside(modalRef, onPress);
  // const onSubmitEditing = (value: {
  //   nativeEvent: {
  //     text: string;
  //     eventCount: number;
  //     target: string;
  //   };
  // }) => {
  //   onSave(value.nativeEvent.text);
  // };

  const renderContent = () => (
    <View ref={(view) => (modalRef.current = view)} style={[styles.tooltip]}>
      <ScrollView
        style={{
          paddingHorizontal: Metrics.padding6,
          backgroundColor: Colors.white,
        }}
      >
        <STagsBar tags={tags} type={STagType.Plain} noShare flexWrap />
      </ScrollView>
    </View>
  );

  return (
    <View
      style={styles.wrapper}
      onLayout={(e) => {
        setContainerWidth(e.nativeEvent.layout.width);
        //        console.log(`WIDTH: ${e.nativeEvent.layout.width}`);
      }}
    >
      <Pressable
        style={styles.container}
        onPress={onPress}
        onMouseEnter={onTagsHoverIn}
        onMouseLeave={onTagsHoverOut}
        onPressIn={onTagsPressIn}
        onPressOut={onTagsPressOut}
      >
        <ScrollView horizontal>
          <View style={styles.content}>
            <STagsBar
              tags={tags}
              type={STagType.Plain}
              onWidth={onWidth}
              onClick={onClick}
              onEdit={onEdit}
            />
          </View>
        </ScrollView>
        <View style={styles.icon}>
          <SIcon
            type={SIconType.Pen}
            size={Metrics.iconExtraSmall}
            color={
              tagsHover && !tagsPressIn ? Colors.grey300 : Colors.transparent
            }
          />
        </View>
      </Pressable>

      {isVisible ? (
        <View
          ref={(view) => (modalRef.current = view)}
          style={[styles.modal, { width: (containerWidth * 3) / 4, top: 34 }]}
        >
          <ScrollView
            style={{
              paddingHorizontal: Metrics.padding6,
              backgroundColor: Colors.white,
            }}
          >
            <STagsBar
              tags={tags}
              type={STagType.Edited}
              onClick={onClick}
              onEdit={onEdit}
              noShare
              flexWrap
            />
          </ScrollView>
        </View>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    marginRight: Metrics.iconExtraSmall,
  },
  container: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    paddingVertical: Metrics.padding6 - 1,
  },
  tooltip: {
    width: 300,
    height: 76,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: Colors.grey200,
    shadowColor: Colors.midnight80,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 4,
  },
  modal: {
    position: "absolute",
    zIndex: 2,
    width: 300,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: Colors.grey200,
    shadowColor: Colors.midnight80,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 4,
  },
  titleText: {
    ...Typography.bodyNumber,
    color: Colors.grey900,
    textTransform: "uppercase",
    fontWeight: "700",
  },
  content: {
    height: 64,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: Metrics.padding16,
  },
  footer: {
    flexDirection: "row",
    height: 48,
    alignItems: "center",
    justifyContent: "flex-end",
    paddingRight: 8,
    borderTopWidth: 1,
    borderColor: Colors.grey200,
  },
  icon: {
    position: "absolute",
    right: -Metrics.iconExtraSmall - 5,
  },
});

export default STagsEditBar;
function ref(ref: any, arg1: () => any) {
  throw new Error("Function not implemented.");
}
